//
//  IsnLogo.tsx
//
//  isana.net,inc. Proprietary and Confidential
//
import { Link } from "react-router-dom";
import { PUBLIC_URL } from "../utils/env";
import { Box } from "@mui/material";

const IsnLogo = () => {
  return (
    <Box display={"flex"}>
      <Link to="https://www.isana.net">
        <img
          className="logo-image"
          src={`${PUBLIC_URL}/isana.net_logo_mark-side.png`}
          alt="イサナドットネット株式会社"
        />
      </Link>
    </Box>
  );
};

export default IsnLogo;
